'use client';

// Providers
import { useProject } from '@/providers';
const ProjectArchivedOverlay = () => {
  const {
    project
  } = useProject();
  const isProjectArchived = project?.projectInfo?.archived;

  // Only show overlay if the project is archived
  return isProjectArchived && <div className="absolute inset-0 bg-slate-600/40 z-30 cursor-not-allowed" />;
};
export default ProjectArchivedOverlay;